<template>
    <div class="w-full relative">
        <input class="w-full border-2 text-lg text-white p-2 border-gradient-to-br from-purple to-blue bg-dark-blue focus:outline-none focus:from-yellow focus:via-white focus:to-yellow" :class="prefix ? 'pl-5' : ''" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" v-bind="$attrs">
        <span v-text="prefix" class="absolute text-white text-lg left-2 top-[9.5px] select-none" v-if="prefix"></span>
    </div>
</template>

<script>
export default {
    inheritAttrs: false
}
</script>

<script setup>
defineProps(['modelValue', 'prefix']);
defineEmits(['update:modelValue']);
</script>